import TextareaWithUploader from '../inputs/AsyncTextareaWithUploader';
import { connect } from 'react-redux';
import { change } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];

  return {
    attachments: state.attachmentsTmap
      ? state.attachmentsTmap[question.name]
      : [],
    isValid: question.isValid,
    value: question.values[0].value,
    ...state.attachmentConfig,
    attachmentParams: {
      attachment: {
        surveyQuestionId: ownProps.questionId,
        tempMultiAttachmentKey: question.tempMultiAttachmentKey,
      },
      attachableId: question.tempMultiAttachmentKey,
      attachableType: 'Survey::Response',
      tokenId: state.token.id,
    },
    tempMultiAttachmentKeyFieldName: `questions[images][${question.name}][]`,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => dispatch(change(e.target.value, ownProps.questionId)),
});

const DiscussionTextarea = connect(mapStateToProps, mapDispatchToProps)(
  TextareaWithUploader
);

export default DiscussionTextarea;
